import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";
import {BuilderSectionsInteractionService} from "../../../../../../builder-sections-interaction.service";
import {DbValidators} from "../../../../../../../shared/validators/DbValidators";
import {Config} from "../../../../../../../config/config";
import {CookieService} from "ngx-cookie";
import {VibeCodingFlowService} from "../../../../../../../shared/services/vibe-coding-flow.service";
import {Website} from "../../../../../../../websites/website/website";

@Component({
    selector: 'db-site-description-edit',
    templateUrl: './site-description-edit.component.html',
    styleUrl: './site-description-edit.component.scss',
    standalone: false
})
export class SiteDescriptionEditComponent {
  @Output() closeDescription = new EventEmitter<void>();

  @Input() set description(value: string) {
    this.descriptionControl.setValue(value);
    this.descriptionControl.markAsPristine();
  }
  @Input() website: Website;

  @Output() onEvent: EventEmitter<{
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
  }> = new EventEmitter<{
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
  }>();

  descriptionControl = new FormControl('', [DbValidators.trimStart, Validators.minLength(20), Validators.maxLength(1000), Validators.required]);

  constructor(public builderInteractionsService: BuilderSectionsInteractionService,
              private _vibeCodingFlowService: VibeCodingFlowService) {
  }

  saveChanges() {
    const vibeCodingFlow = this._vibeCodingFlowService.isVibeCodingFlow() || this.website?.isWVC;

    const siteInfo = this.builderInteractionsService.siteInfo.value;
    this.builderInteractionsService.siteInfo.next({...siteInfo, business_description: this.descriptionControl.value});
    this.descriptionControl.markAsPristine();
    this.onEvent.emit({
      eventCategory: 'Onboarding',
      eventAction: (vibeCodingFlow ? 'Vibe-coding AI Flow' : 'Section-based AI Flow') + ' - Description - Apply',
      eventLabel: '-'
    });
    this.closeDescription.next();
  }
}
